"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBasketDetailsRedis = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _validators = require("../validators");
var _base = require("./base64");
var _formatBasicBasketDetails = require("./formatBasicBasketDetails");
var setBasketDetailsRedis = exports.setBasketDetailsRedis = function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (basket, reservationId) {
    var isBB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var redisMutation = arguments.length > 3 ? arguments[3] : undefined;
    var {
      mutation,
      isLoading,
      isSuccess,
      isError
    } = redisMutation;
    if (reservationId && (0, _validators.isStringValid)(reservationId)) {
      var basketToBeSet = (0, _formatBasicBasketDetails.formatBasicBasketDetails)(basket, reservationId, isBB);
      if (!isLoading && !isSuccess && !isError) {
        yield mutation.mutate({
          basket: (0, _base.encodeToBase64)(JSON.stringify(basketToBeSet))
        });
      }
    }
  });
  return function setBasketDetailsRedis(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();